import 'reflect-metadata';

export function MetaTitle(title: string) {
  return function (target: any) {
    Reflect.defineMetadata('title', title, target);
  };
}
